// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import VueLazyload from 'vue-lazyload'
import router from './router'
import Axios from 'axios'
import qs from 'qs'


import Uploader from 'vant/lib/uploader';
import 'vant/lib/uploader/style'
import Loading from  'vant/lib/loading';
import 'vant/lib/loading/style'
import 'babel-polyfill'
//import Mint from 'mint-ui'
import { InfiniteScroll, Spinner, Search, IndexList, IndexSection, Cell, Field, DatetimePicker,Radio } from 'mint-ui'

import 'mint-ui/lib/style.css'
import './assets/my-mint.css'
import "./style/base.css"
import "./style/style.css"
import './assets/validate'

import { MessageBox, Toast } from "mint-ui"

// import VConsole from 'vconsole'
// new VConsole();


Axios.interceptors.request.use(config=>{
  if(config.url.indexOf("upload") > -1){
    config.headers['Content-Type'] = 'multipart/form-data';
  }else if(config.url.indexOf("intentUser") > -1 && config.method == 'post'){
    config.headers['Content-Type'] = "application/json;charset=UTF-8"
  }else{
    config.headers['Content-Type'] = 'application/x-www-form-urlencoded';
    if(config.method == 'post'){
      config.data = qs.stringify({...config.data})
    }
  }
  return config
}, err=>{
  console.log('Error')
  return Promise.reject(err)
})
Vue.prototype.$http = Axios
//Vue.prototype.$http.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';
Vue.prototype.$http.defaults.baseURL = process.env.BASE_API
Vue.prototype.qs = qs

Vue.prototype.addLog = (content, other)=>{
  let url = '/bicycle/inter/addLog'
  let params = {'content': content, 'other': other};
  Axios.post(url, params).then(resp=>{}).catch(err=>{console.log(err)});
}

Vue.config.errorHandler = (error, vm)=>{
  Vue.addLog(JSON.stringify(error), "全局捕获的错误");
}

Vue.config.productionTip = false

Vue.prototype.jsConfig = (wx, callback) => {

  const domainUrl = encodeURIComponent(window.location.href);
 
  let url = '/bicycle/inter/getWechatSign?url='+domainUrl;
  Axios.get(url).then(res =>{
      if(res.data.status  == 200){
        let data = res.data.data;

        let configData = {
            debug: false,
            appId: data.appId,
            timestamp: data.timestamp,
            nonceStr: data.nonceStr,
            signature: data.signature,
            jsApiList:[],
            openTagList: ['wx-open-subscribe']
        };
        wx.config(configData);

        wx.ready(()=>{

        });
        wx.error((err) => {
          MessageBox.alert("注册微信信息失败");
        })
      }else{
          MessageBox.alert("获取微信信息失败");
      }
    });
  }
Vue.prototype.getTemplateList = (callback =>{
  let url = '/bicycle/inter/getTemplateList';
  Axios.get(url).then(res => {
    if(res.data.status == 200){
      callback(res.data.data);
    }else{
      MessageBox.alert(res.data.errorMsg);
    }
  }).catch(err=>{
    console.log(err);
    MessageBox.alert("网络错误，无法获取微信订阅信息")
  })
})

Vue.use(InfiniteScroll)

Vue.use(VueLazyload, {
  preLoad: 1, // 预压高度的比例
  error: '/abc/static/error.png', // 图像的加载失败时 显示的error图标
  loading: '/abc/static/loading.gif', // 图像正常加载时 显示的loading图标
  attempt: 3 // 图像尝试加载 次数
})
Vue.component(Spinner.name, Spinner)
Vue.component(Search.name, Search)
Vue.component(Cell.name, Cell)
Vue.component(IndexList.name, IndexList)
Vue.component(IndexSection.name, IndexSection)
Vue.component(Field.name, Field)
Vue.component(DatetimePicker.name, DatetimePicker);
Vue.component(Radio.name, Radio)
Vue.component(Uploader.name, Uploader)
Vue.component(Loading.name, Loading)

Vue.config.ignoredElements = ['wx-open-subscribe']

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js